import React from "react"
import Cabecalho from "../Cabecalho"
import { FormularioDadosFornecedor } from "./components/FormularioDadosFornecedor"

export function DadosFornecedor() {
    return (
        <>
            <Cabecalho pagina="Dados do Fornecedor" />
            <FormularioDadosFornecedor />
        </>
    )
}
